var map = {
	"./bottom_icon1.png": 5010,
	"./bottom_icon1_act.png": 3563,
	"./bottom_icon2.png": 2328,
	"./bottom_icon3.png": 4497,
	"./bottom_icon4.png": 8230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1992;